import { gql } from "@apollo/client";
import moment from "moment";

const PRODUCTO = 1;
const TECNOLOGIAS_MEDICAS = 2;

const GET_INFORME_RECLAMO = gql`
query informeReclamoById ( $idGestionReclamo: Int!) {
    informeReclamoById( idGestionReclamo: $idGestionReclamo ){
        reclamo{
            numeroReclamo
            fechaRegistro
            idDelegacionNavigation{
                descripcion
            }
            idUsuarioCreadorNavigation{
                nombre
                apellido
            }
            idPacienteNavigation{
                nombre
                apellido
            }
            cliente{
                nom_com
                cod_Cliente
            }
            idSeguimientoFK
            capa
            idCapaReclamo
            idAreaReclamoNavigation{
                descripcion
            }
            gestionReclamoProfesional{
                idProfesionalNavigation{
                    nombre
                    apellido
                }
            }

            tipoInsumoReclamo{
                idInsumoNavigation{
                    descripcion
                }
                lote
                fechaVencimiento
                numeroRemito
                fechaRemito
                cantidad
                identificadorInsumo
            }

            descripcionCalidad

            accionInmediataCalidad

            investigacion

            descripcionCierre

            observacionFinal
            correspondeProfesional
        }
        historialReclamo{
            fechaRealizacion
            idUsuarioNavigation{
                nombre
                apellido
            }
        }
        esJefe
        puesto
    }
}
`;
export default GET_INFORME_RECLAMO;

export const adaptInformeReclamo = (informe) => {
  return {
    numeroReclamo: informe?.reclamo?.numeroReclamo,
    fechaRegistro: moment(informe?.reclamo?.fechaRegistro).format('DD/MM/YYYY'),
    delegacion: informe?.reclamo?.idDelegacionNavigation?.descripcion,
    usuario: `${informe?.reclamo?.idUsuarioCreadorNavigation?.nombre} ${informe?.reclamo?.idUsuarioCreadorNavigation?.apellido}`,
    paciente: `${informe?.reclamo?.idPacienteNavigation?.nombre} ${informe?.reclamo?.idPacienteNavigation?.apellido}`,
    financiador: `${informe?.reclamo?.cliente?.cod_Cliente} - ${informe?.reclamo?.cliente?.nom_com}`,
    profesionales: informe?.reclamo?.gestionReclamoProfesional?.map((p) => `${p?.idProfesionalNavigation?.nombre} ${p?.idProfesionalNavigation?.apellido}`),
    idSeguimientoFK: informe?.reclamo?.idSeguimientoFK,
    capa: informe?.reclamo?.capa,
    idCapa: informe?.reclamo?.idCapaReclamo,
    area: informe?.reclamo?.idAreaReclamoNavigation?.descripcion,
    productos: informe?.reclamo?.tipoInsumoReclamo?.map((x) => {
      const { identificadorInsumo, idInsumoNavigation, ...data } = x;
      return {
        ...data,
        tipo: identificadorInsumo === TECNOLOGIAS_MEDICAS ? 'Tec. médica' : 'Producto',
        nombre: idInsumoNavigation?.descripcion
      };
    }),
    descripcion: informe?.reclamo?.descripcionCalidad,
    accionInmediata: informe?.reclamo?.accionInmediataCalidad,
    investigacion: informe?.reclamo?.investigacion,
    descripcionCierre: informe?.reclamo?.descripcionCierre,
    observacionFinal: informe?.reclamo?.observacionFinal,
    firmante: `${informe?.historialReclamo?.idUsuarioNavigation?.nombre} ${informe?.historialReclamo?.idUsuarioNavigation?.apellido}`,
    fechaFirma: moment(informe?.historialReclamo?.fechaRealizacion).format('DD/MM/YYYY HH:mm'),
    tituloFirmante: informe?.esJefe ? 'Jefe de Aseguramiento de Calidad Nutri Home S.A.' : informe?.puesto+' Nutri Home S.A.',
    correspondeProfesional: informe?.reclamo?.correspondeProfesional
  };
};